//银行变更日志
export const bankLogColumns1 = [
  {code:"index",name:"序号", width:60},
  {code:"changeTypeDesc", name:"日志类型", width:100, wareTip:true },
  {code:"userName",name:"门店名称", width:150},
  {code:"modifyAfter",name:"日志操作", width:100},
  {code:"updateTime",name:"操作时间", width:200}
];

//银行信息
export const bankInfoColumns1 = [
    { code:"clientId", name:"门店编码"},
    { code:"userName", name:"门店名称"},
    { code:"bankName", name:"开户银行"},
    { code:"bankAccount", name:"开户账号"},
    { code:"bankAccountName", name:"开户名称"}
];

//表格列
export const tableColumns = [
  // 资金列表
  [
    {
      code:"index",
      name:"序号"
    },
    {
      code:"clientId",
      name:"门店编号"
    },{
      code:"phone",
      name:"门店账号"
    },
    {
      code:"userName",
      name:"门店名称"
    },{
      code:"userType",
      name:"门店类型"
    },
    // {
    //   code:"statsDesc",
    //   name:"资金账户状态"
    // },
    {
      code:"parentId",
      name:"归属客户编号"
    },
    {
      code:"parentName",
      name:"归属客户名称"
    },
    {
      code:"parentType",
      name:"归属客户类型"
    },
    {
      code:"moneyAmount",
      name:"预付款(合计)",
      fundFormatter: true,
      dtClass:"text-right"
    },
    {
      code:"option",
      name:"操作"
    }
  ],

  // 门店银行账号列表
  [
    {
      code:"index",
      name:"序号"
    },
    {
      code:"clientId",
      name:"门店编号"
    },
    {
      code:"userName",
      name:"门店名称"
    },
    {
      code:"bankName",
      name:"开户银行"
    },
    {
      code:"bankAccount",
      name:"开户行账号"
    },
    {
      code:"bankAccountName",
      name:"开户名称"
    },
    {
      code:"attributionCustomerId",
      name:"归属客户编号"
    },
    {
      code:"attributionCustomerName",
      name:"归属客户名称"
    },
    {
      code:"attributionCustomerType",
      name:"归属客户类型"
    },
    // {
    //   code:"moneyAmount",
    //   name:"预付款(合计)",
    //   fundFormatter: true,
    //   dtClass:"text-right"
    // },
    {
      code:"option",
      name:"操作"
    }
  ],
  //收支明细
  [
    {
      code:"index",
      name:"序号"
    },
    {
      code:"userType",
      name:"门店类型"
    },{
      code:"userName",
      name:"门店名称"
    },{
      code:"bodyName",
      name:"主体名称"
    },{
      code:"accountType",
      name:"账户类型"
    },
    {
      code:"phone",
      name:"门店账号"
    },
    {
      code:"clientId",
      name:"门店编号"
    },{
      code:"afterAmount",
      name:"资金余额/元",
      fundFormatter: true,
      dtClass:"text-right"
    },
    {
      code:"changeAmount",
      name:"资金变动数/元",
      fundFormatter: true,
      dtClass:"text-right"
    },{
      code:"changeType",
      name:"往来类型"
    },{
      code:"mark",
      name:"往来备注"
    },
    {
      code:"updateTime",
      name:"发生时间"
    }
  ],
  //转账充值记录
  [
    {
      code:"index",
      name:"序号",
      width:80
    },{
      code:"userName",
      name:"门店名称",
      width:150
    },{
      code:"bodyName",
      name:"主体名称"
    },{
      code:"accountType",
      name:"账户类型"
    },
    {
      code:"clientId",
      name:"门店编码",
      width:150
    },{
      code:"cardSerialNumber",
      name:"银行流水号",
      width: 200
    },
    {
      code:"bankName",
      name:"开户银行",
      width: 200
    },{
      code:"bankAccount",
      name:"开户账号",
      width: 200
    },{
      code:"chargeAmount",
      name:"转账金额/元",
      width: 200,
      fundFormatter: true,
      dtClass:"text-right"
    },
    {
      code:"chargeTime",
      name:"转账时间",
      width: 200
    },
    {
      code:"updateTime",
      name:"操作时间",
      width: 200
    },
    {
      code:"statsDesc",
      name:"转账状态",
      wareTip: "true",
      width: 200
    },
    {
      code:"mark",
      name:"备注",
      tdClass: 'warn-text',
      width: 100
    },
    {
      code:"option",
      name:"操作",
      width: 180
    }
  ]
]